import { CourseMappingColumn } from '../../interfaces/CourseMappingInterface';
import { COURSE_MAPPING_COLUMNS } from './courseMappingColumns';

export interface CourseMappingColumnLayout {
  visible: CourseMappingColumn[];
  // Hidden columns in the gap immediately before a visible column, keyed by that column's key.
  hiddenBefore: Record<string, CourseMappingColumn[]>;
  hiddenTrailing: CourseMappingColumn[];
}

export const getVisibleColumns = (hidden: Set<string>): CourseMappingColumn[] =>
  COURSE_MAPPING_COLUMNS.filter((column) => !hidden.has(column.key));

export const buildColumnLayout = (hidden: Set<string>): CourseMappingColumnLayout => {
  const visible: CourseMappingColumn[] = [];
  const hiddenBefore: Record<string, CourseMappingColumn[]> = {};
  let pendingHidden: CourseMappingColumn[] = [];

  COURSE_MAPPING_COLUMNS.forEach((column) => {
    if (hidden.has(column.key)) {
      pendingHidden.push(column);
      return;
    }

    if (pendingHidden.length > 0) {
      hiddenBefore[column.key] = pendingHidden;
      pendingHidden = [];
    }

    visible.push(column);
  });

  return { visible, hiddenBefore, hiddenTrailing: pendingHidden };
};
